import 'client/javascript/main';

import WeGlide from 'client/javascript/we_glide/we_glide';
import { Select } from '@wework/ray-core';
import { nearbyBuildingsSliderOptions, nearbyBuildingsSlider } from 'server/controllers/nearby_buildings/constants';

import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { trackInteraction, setupScrollAnalyticsTracking } from 'client/javascript/analytics';
import { setupWizardOverlay } from './wizard/overlay';
import { populateNearbyBuildingsSection, isNearbyBuildingsAvailable, getLocationId } from './nearby_buildings';

const selectorBelowFold = '[data-section-id="home-below-fold"]';
const heroSlider = '.home-hero__glide';

onContentLoaded(() => {
  // This log line can be removed after 11/31/19
  global.LE.info(
    `Data Analytics Troubleshooting - DomContentLoaded on Homepage - userId is ${window.analyticsGlobals.userId}`
  );

  onPolyfillsLoaded(async () => {
    setupSlider(heroSlider);

    await populateLocationDropdown();
    await populateNearbyBuildingsSection();

    if (isNearbyBuildingsAvailable()) {
      setupSlider(nearbyBuildingsSlider, nearbyBuildingsSliderOptions);
    }

    setupWizardOverlay();

    // ANALYTICS
    setupLinkAnalyticsTracking();
    setupScrollAnalyticsTracking({
      label: 'homepage scrolled below the fold',
      selector: selectorBelowFold
    });
  });
});

async function populateLocationDropdown() {
  const locationsDropdownSelect = Select.create(document.getElementById('locations-dropdown-select__container'));
  const locationId = await getLocationId();

  locationsDropdownSelect.set(locationId);
}

function setupSlider(selector, options = {}) {
  const glide = new WeGlide(selector, options);
  glide.mount();
}

/* ANALYTICS: clicking anchor tags below the fold */
function setupLinkAnalyticsTracking() {
  const anchorTagsInSectionBelowFold = document.querySelectorAll(`${selectorBelowFold} a`);
  Array.from(anchorTagsInSectionBelowFold).forEach(anchorTag =>
    anchorTag.addEventListener('click', handleClickAnchorTag)
  );
}

function handleClickAnchorTag(event) {
  const toPath = event.currentTarget.href;
  trackInteraction({ label: 'homepage below the fold content', toPath });
}
